import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { BannerContainer, CloseBtn, TextFrame, InlineLink } from './helpers.js';
import getPgaTld from '../../getPgaTld.js';

var pgaTld = getPgaTld();
var BetaBanner = /*#__PURE__*/function (_React$Component) {
  function BetaBanner(props) {
    var _this;
    _classCallCheck(this, BetaBanner);
    _this = _callSuper(this, BetaBanner, [props]);
    _this.state = {
      isClosed: false
    };
    _this.closeBanner = _this.closeBanner.bind(_this);
    return _this;
  }
  _inherits(BetaBanner, _React$Component);
  return _createClass(BetaBanner, [{
    key: "closeBanner",
    value: function closeBanner() {
      this.setState({
        isClosed: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$feedbackF = this.props.feedbackFormAnchor,
        feedbackFormAnchor = _this$props$feedbackF === void 0 ? "feedback-form-anchor" : _this$props$feedbackF;
      return this.state.isClosed ? null : /*#__PURE__*/React__default.createElement(BannerContainer, null, /*#__PURE__*/React__default.createElement(CloseBtn, {
        onClick: this.closeBanner
      }), /*#__PURE__*/React__default.createElement(TextFrame, null, "Welcome to the PGA.org Beta Experience!", " ", /*#__PURE__*/React__default.createElement(InlineLink, {
        href: "#".concat(feedbackFormAnchor)
      }, "Let us know what you think"), " ", "or", " ", /*#__PURE__*/React__default.createElement(InlineLink, {
        id: "optout",
        href: "https://www.".concat(pgaTld, "/?opt-in=0")
      }, "switch back"), " ", "to the previous experience."));
    }
  }]);
}(React__default.Component);

export { BetaBanner as default };
